import { RouteHttpVerb } from "@devowl-wp/utils";
const locationRestConsentDelete = {
    path: "/consent/:id",
    method: RouteHttpVerb.DELETE
};
export { locationRestConsentDelete };
